import Modal from 'developer_components/newModal';
import Simplebar from 'simplebar';

function HotelOptionsModal(groups, options = {}) {
    const $element = Modal.createFromHTML(
        `<div class="Options-modal">
            <div class="Options-modal__title">Какие удобства вас ждут</div>
            <button class="Options-modal__close js-modalClose" title="Закрыть">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#2A2536"/>
                </svg>
            </button>

            <div class="Options-modal__wrapper js-optionsWrapper" data-simplebar>
                ${groups.map(group => (
                    `<div class="Options-modal__group">
                        <div class="Options-modal__group-title">
                            ${group.title}
                        </div>
                        <ul class="Options-modal__group-list">
                            ${group.options.map(option => (
                                `<li class="Options-modal__group-item">
                                    <div class="Options-modal__group-item-icon">
                                        ${option.icon ?? ''}
                                    </div>
                                    <div class="Options-modal__group-item-info">
                                        <div class="Options-modal__group-item-info-title">${option.title}</div>
                                        ${option.hint ? `<div class="Options-modal__group-item-info-subtitle">${option.hint}</div>` : ''}
                                    </div>
                                </li>`
                            )).join('')}
                        </ul>
                    </div>`
                )).join('')}
            </div>
        </div>`
    );

    Modal.call(this, $element, options);

    this.$optionsWrapper = document.querySelector('.js-optionsWrapper');

    new Simplebar(this.$optionsWrapper, {
        autoHide: false
    });
}

HotelOptionsModal.prototype = Object.create(Modal.prototype);
Object.defineProperty(HotelOptionsModal.prototype, 'constructor', {
    value: HotelOptionsModal,
    enumerable: false,
    writable: true,
});

export default HotelOptionsModal;
